import { render, staticRenderFns } from "./CustomerRenewals.vue?vue&type=template&id=17020a52&scoped=true"
import script from "./CustomerRenewals.vue?vue&type=script&lang=js"
export * from "./CustomerRenewals.vue?vue&type=script&lang=js"
import style0 from "./CustomerRenewals.vue?vue&type=style&index=0&id=17020a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17020a52",
  null
  
)

export default component.exports